import { Component, Inject, OnInit } from '@angular/core';
import { PlatformAppContext } from '@/app/platform/platform-context/platform-app-context';
import { Notifier, NOTIFIER } from '@shared/notifier/types';

@Component({
    selector: 'app-root-index-page',
    templateUrl: './app-root-index-page.component.html',
    styleUrls: ['./app-root-index-page.component.css'],
    standalone: false
})
export class AppRootIndexPageComponent implements OnInit {
  constructor(
    readonly egiAppContext: PlatformAppContext,
    @Inject(NOTIFIER)
    readonly notifier: Notifier
  ) {}

  ngOnInit(): void {}
}
